import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/296'

const OrdersByHandoffModeTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.orders_by_handoff_mode"
  />
)

export default OrdersByHandoffModeTab
